import { Clear } from '@mui/icons-material';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  Switch,
  TextField,
  Autocomplete
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { SytemNotification } from 'types/AppTypes';

import { types } from '../NotificationTypes';

export function SystemNotificationInformation() {
  const { t } = useTranslation();

  const { touched, errors, values, setFieldValue } = useFormikContext<SytemNotification>();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field
            as={TextField}
            name="headline"
            error={errors.headline}
            helperText={errors.headline}
            fullWidth
            required
            label={t(translations.pages.systemNotificationsSettings.headline())}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            as={TextField}
            name="content"
            fullWidth
            error={errors.content}
            helperText={errors.content}
            required
            multiline
            rowsMax={3}
            label={t(translations.pages.systemNotificationsSettings.content())}
          />
        </Grid>
        <Grid item xs={3}>
          <DatePicker
            renderInput={props => (
              <TextField
                {...props}
                variant="outlined"
                required
                label={t(translations.pages.systemNotificationsSettings.startDate())}
                error={touched.startDate && Boolean(errors.startDate)}
                helperText={<>{errors.startDate}</>}
                fullWidth
              />
            )}
            disablePast
            inputFormat="dd.MM.yyyy"
            value={values.startDate ? values.startDate : null}
            onChange={e => setFieldValue('startDate', e)}
          />
        </Grid>
        <Grid item xs={3}>
          <DatePicker
            renderInput={props => (
              <TextField
                {...props}
                variant="outlined"
                required
                label={t(translations.pages.systemNotificationsSettings.endDate())}
                error={touched.endDate && Boolean(errors.endDate)}
                helperText={<>{errors.endDate}</>}
                fullWidth
                InputProps={
                  values.endDate && {
                    endAdornment: (
                      <IconButton
                        size="small"
                        onClick={() => {
                          setFieldValue('endDate', null, true);
                        }}
                      >
                        <Clear />
                      </IconButton>
                    )
                  }
                }
              />
            )}
            disablePast
            inputFormat="dd.MM.yyyy"
            value={values.endDate ? values.endDate : null}
            onChange={e => setFieldValue('endDate', e)}
          />
        </Grid>
        <Grid item xs={4}>
          <Autocomplete
            options={types}
            value={values.type && types.find(type => type.value === values.type)}
            autoHighlight
            fullWidth
            getOptionLabel={option => (typeof option !== 'string' ? option.label : '')}
            onChange={async (event, value, reason) => {
              setFieldValue('type', value ? value.value : null, true);
            }}
            renderInput={params => (
              <TextField
                {...params}
                error={touched.type && Boolean(errors.type)}
                helperText={errors.type}
                fullWidth
                label={t(translations.pages.systemNotificationsSettings.type())}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'new-password'
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={2}>
          <FormControl
            className="role-detail-modal__body__input"
            required
            fullWidth
            error={touched.isActive && Boolean(errors.isActive)}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={values.isActive}
                  onChange={v => {
                    setFieldValue('isActive', v.target.checked);
                  }}
                  name="isActive"
                  color="primary"
                />
              }
              label={t(translations.pages.systemNotificationsSettings.isActive())}
            />
            {errors.isActive && <FormHelperText>{errors.isActive}</FormHelperText>}
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}
